import React from "react";

const Product = ({ product, onAdd }) => {
  return (
    <div className="product">
      <div className="img__container">
        <img src={product.image} alt="" />
      </div>
      <div className="product__bottom">
        <div className="rating">
          <span>
            <svg>
              <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
            </svg>
          </span>
          <span>
            <svg>
              <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
            </svg>
          </span>
          <span>
            <svg>
              <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
            </svg>
          </span>
          <span>
            <svg>
              <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
            </svg>
          </span>
          <span>
            <svg>
              <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
            </svg>
          </span>
        </div>
        <h3>{product.name}</h3>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            onAdd(product);
          }}
        >
          Add To Cart
        </a>
        {/* <a onClick={() => onAdd(product)}>ADD</a> */}
      </div>
    </div>
  );
};

export default Product;
